var map = {
	"./img.png": "./src/assets/images/file/img.png",
	"./pdf.png": "./src/assets/images/file/pdf.png",
	"./xlsx.png": "./src/assets/images/file/xlsx.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/file sync recursive ^\\.\\/.*\\.png$";